// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + (chunkId === 962 ? "store" : chunkId) + "." + {"453":"4755c8d2","962":"b9b0ba48"}[chunkId] + ".chunk.js");